module.exports = __webpack_public_path__ + "static/media/DINbek-01.379b0b4a.svg";